<app-tdo-progress-spinner *ngIf="isLoading" data-cy="letter-template-loading-spinner"></app-tdo-progress-spinner>
<div *ngIf="!isLoading" class="section" style="flex: 1; display: flex; flex-direction: column;" data-cy="letter-template-container">
  <div class="section-header" style="flex-basis: fit-content;" data-cy="letter-template-header">
    <div class="section-header-title" data-cy="letter-template-title">Select a Letter Template</div>
  </div>
  <div class="section-content"
       style="display: block; flex-direction: column; flex: 1; padding: 0px 0px 0px 0px !important;"
       data-cy="letter-template-content">

    <div class="main-content-container" data-cy="letter-template-main-container">
      <tdo-table #letterTemplateListTable *ngIf="!isLoading  && letterTemplateList"
                 [dataSource]="letterTemplateList" [isSearchable]="true" [searchPredicate]="searchPredicate"
                 (rowSelected)="onRowSelected($event)"
                 style="overflow-y: auto"
                 data-cy="letter-template-table">
        <tdo-table-column displayName="Name" propertyName="LetterName" isSortable="true" [rowTemplate]="LetterName" data-cy="letter-template-name-column">
          <ng-template #LetterName let-row>
            <div style="max-width: 300px;" data-cy="letter-template-name-{{row.index}}">
              {{row.model.LetterName}}
            </div>
          </ng-template>
        </tdo-table-column>
      </tdo-table>
    </div>
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="letter-template-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="letter-template-footer-spacer"></div>
      <button (click)="onOkAction()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="letter-template-ok-button">OK</button>
      <button (click)="close()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="letter-template-close-button">Close</button>
    </div>

  </div>
